export default "__VITE_ASSET__2ad55bac__"